import Phaser from 'phaser';
import { CST } from '../CST';
import { Score } from '../controller/score.js';

var actualStory;
var soundOn = 1;

export default class UIScene extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.UISCENE);
	}

	create(data) {
		this.bgMusic = this.sound.add('main-soundtrack', {
			loop: true,
			volume: 0.3,
		});

		this.clickSound = this.sound.add('click-sound', {
			volume: 0.5,
		});
		const mainCam = this.cameras.main;
		mainCam.setBounds(0, 0, 4401, 7019); //Left, Top, X Limit, Y Limit
		mainCam.setZoom(0.6); //0.8
		mainCam.centerOn(1100, 800); //1100, 700

		this.score = new Score(this);
		this.score.createScoreBox();

		this.next = this.add.image(1900, 960, 'next-btn').setScrollFactor(0, 0).setDepth(1.1); //y=980
		this.previous = this.add.image(1500, 960, 'previous-btn').setScrollFactor(0, 0).setDepth(1.1); //y=980
		this.pause = this.add.image(1700, 960, 'pause-btn').setScrollFactor(0, 0).setDepth(1.1); //y=980
		this.User_ID = data.User_ID;

		switch (data.story) {
			case 1:
				this.scene.launch(CST.SCENES.STORYBOARD_1, this);
				actualStory = 1;
				this.scene.bringToTop();
				break;
			case 2:
				this.scene.launch(CST.SCENES.STORYBOARD_2, this);
				actualStory = 2;
				this.scene.bringToTop();
				break;
			case 3:
				this.scene.launch(CST.SCENES.STORYBOARD_3, this);
				actualStory = 3;
				this.scene.bringToTop();
				break;
			case 4:
				this.scene.launch(CST.SCENES.STORYBOARD_4, this);
				actualStory = 4;
				this.scene.bringToTop();
				break;
			case 5:
				this.scene.launch(CST.SCENES.STORYBOARD_5, this);
				actualStory = 5;
				this.scene.bringToTop();
				break;
			case 6:
				this.scene.launch(CST.SCENES.STORYBOARD_6, this);
				actualStory = 6;
				this.scene.bringToTop();
				break;
			case 7:
				this.scene.launch(CST.SCENES.STORYBOARD_7, this);
				actualStory = 7;
				this.scene.bringToTop();
				break;
			default:
				this.scene.launch(CST.SCENES.MAIN_STORYBOARD, this);
				actualStory = 0;
				this.scene.bringToTop();
				break;
		}

		this.pause
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.next.disableInteractive();
					this.previous.disableInteractive();
					this.pause.disableInteractive();

					let black_bg = this.add
						.image(0, 0, 'black-bg')
						.setScale(8)
						.setAlpha(0.4)
						.setDepth(1.2)
						.setOrigin(0);

					let resume = this.add
						.image(
							this.cameras.main.width / 2 + 500,
							this.cameras.main.height / 2 + 100,
							'next-btn',
						)
						.setInteractive({
							useHandCursor: true,
						})
						.on(
							'pointerdown',
							() => {
								this.next.setInteractive();
								this.previous.setInteractive();
								this.pause.setInteractive();

								black_bg.destroy();
								resume.destroy();
								exit_story.destroy();
								sound.destroy();
							},
							this,
						)
						.setScale(1.5)
						.setDepth(1.3);

					let exit_story = this.add
						.image(
							this.cameras.main.width / 2 + 500,
							this.cameras.main.height / 2 + 400,
							'home-btn',
						)
						.setInteractive({
							useHandCursor: true,
						})
						.on(
							'pointerdown',
							() => {
								this.next.setInteractive();
								this.previous.setInteractive();
								this.pause.setInteractive();

								black_bg.destroy();
								resume.destroy();
								exit_story.destroy();
								sound.destroy();

								switch (actualStory) {
									case 1:
										this.scene.stop(CST.SCENES.STORYBOARD_1);
										break;
									case 2:
										this.scene.stop(CST.SCENES.STORYBOARD_2);
										break;
									case 3:
										this.scene.stop(CST.SCENES.STORYBOARD_3);
										break;
									case 4:
										this.scene.stop(CST.SCENES.STORYBOARD_4);
										break;
									case 5:
										this.scene.stop(CST.SCENES.STORYBOARD_5);
										break;
									case 6:
										this.scene.stop(CST.SCENES.STORYBOARD_6);
										break;
									case 7:
										this.scene.stop(CST.SCENES.STORYBOARD_7);
										break;
									default:
										//this.scene.stop(CST.SCENES.MAIN_STORYBOARD);
										break;
								}

								if (actualStory === 0) {
									/*this.next.setVisible(false);
                    this.previous.setVisible(false);
                    this.pause.setVisible(false);
                    this.scene.launch(CST.SCENES.STORY_SELECT, {
                        User_ID: this.User_ID
                    });
                    this.scene.bringToTop();*/
								} else {
									this.next.setVisible(false);
									this.previous.setVisible(false);
									this.pause.setVisible(false);
									this.scene.resume(CST.SCENES.STORY_SELECT, {
										User_ID: this.User_ID,
									});
									this.scene.bringToTop();
								}
							},
							this,
						)
						.setScale(1.5)
						.setDepth(1.3);

					let sound = this.add
						.image(
							this.cameras.main.width / 2 + 500,
							this.cameras.main.height / 2 + 700,
							'sound-on-btn',
						)
						.setInteractive({
							useHandCursor: true,
						})
						.on(
							'pointerdown',
							() => {
								if (soundOn === 1) {
									soundOn = 0;
									sound.setTexture('sound-off-btn');
									this.game.sound.mute = true;
								} else {
									soundOn = 1;
									sound.setTexture('sound-on-btn');
									this.game.sound.mute = false;
								}
							},
							this,
						)
						.setScale(1.5)
						.setDepth(1.3);
				},
				this,
			);
	}

	update() {}
}
